'use strict'

/**
 * Exception thrown when the message does not have the required data.
 */
class ExIncompleteMessage {
  /**
     * @param {string} source The name of the function that threw the exception.
     * @param {EPending|ELiving|EDying} entry The entry that requested more
     * information.
     * @param {MResponse} message The message lacking data.
     */
  constructor (source, entry, message) {
    this.source = source
    this.entry = entry
    this.message = message
  }
};

module.exports = ExIncompleteMessage
